import styled, { keyframes } from 'styled-components'

import { colors } from '../../theme'

export const ContainerModalSend = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 1.5%;
  background-color: ${colors.overlay};
  display: block;
  z-index: 2;
`

export const SendStyle = styled.div`
  width: 720px;
  background-color: ${colors.surface};
  border-radius: 26px 26px 24px 24px;
  margin: 0 auto;
  text-align: center;
  height: auto;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`
// Miolo rolável do modal: cabecalho (dias) e rodape (botoes) ficam fixos;
// so este bloco rola quando o conteudo estoura, mantendo a barra DENTRO do card.
export const ScrollBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  width: 100%;
`
export const DivImg = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 24px 24px 0 0;
  padding: 20px 20px 0px 20px;
`
export const DivBotoes = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 24px 24px 0 0;
  padding: 14px 20px 20px 25px;
`
export const DivChecked = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 24px 24px 0 0;
  padding: 10px 20px 0px 25px;
  margin-bottom: 10px;
`
export const DivCheckedInput = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
`
export const DivAddProduto = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 24px 24px 0 0;
  padding: 15px 20px 0px 15px;
`
export const ContainerCards = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  width: 100%;
  padding: 35px 20px 20px 20px;
  text-align: left;
`
export const ContainerTable = styled.div<{ padding: boolean }>`
  height: 290px;
  overflow: auto;
  width: 100%;
  padding-left: 20px;
  padding-right: ${({ padding }) => (padding ? '5px' : '20px')};
  text-align: left;
`

export const Closed = styled.div`
  color: ${colors.errorText};
  font-size: 14px;
  cursor: pointer;
`
export const CancelarBaixa = styled.button`
  background: ${colors.surface};
  border: solid 1px ${colors.grey300};
  border-radius: 500px;
  padding: 5px 5px 0px 5px;
  cursor: pointer;
`
export const Span = styled.button`
  position: absolute;
  top: 5px;
  left: 80px;
  border: none;
  background-color: transparent;
`
export const Search = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  font-size: 14px;
`
export const InputStyle = styled.input<{
  sizeY: string
  sizeX: string
}>`
  outline: none;
  border: 1px solid ${colors.grey400};
  border-radius: 8px;
  padding: 11px;
  padding-right: 15px;
  width: ${({ sizeX }) => sizeX};
  height: ${({ sizeY }) => sizeY};
  font-size: 13px;
  margin-left: 7px;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`
export const DivInput = styled.div`
  position: relative;
`
// NAO mexer na largura: alem do rodape deste modal, `Buttons` e importado pelos modais de
// "Enviar pedido em massa" e "Dar baixa em massa" (pages/Predictions), onde os 150px sao o que
// comprime o BtnSave de 200px. Para o rodape com dois botoes existe o AcoesRodape abaixo.
export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
`

// Acoes da direita no rodape do modal de criar pedido: Gerar PDF + Enviar, lado a lado.
export const AcoesRodape = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
`
export const BtnSave = styled.button`
  margin: 0 auto;
  cursor: pointer;
  background-color: ${colors.accentBg};
  color: ${colors.white};
  border: none;
  width: 200px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`

// Acao secundaria ao lado do "Enviar": gerar o PDF nao envia nada ao cliente, entao e um
// botao contornado (nao preenchido), para nao competir com a acao principal do modal.
export const BtnPdf = styled.button`
  cursor: pointer;
  background-color: ${colors.surface};
  color: ${colors.primaryText};
  border: 1px solid ${colors.secondary};
  height: 30px;
  padding: 0 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  white-space: nowrap;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`

const girar = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled.span`
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: ${colors.primaryText};
  border-radius: 50%;
  animation: ${girar} 0.7s linear infinite;
`
export const TypesFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 6px;
  width: 100%;
  height: 42px;
  font-size: 12px;
  background: ${colors.grey200};
  border-radius: 8px;
`
export const Filters = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  background: none;
  border: none;
  height: 100%;
  width: 170px;
  cursor: pointer;
`
export const FilterProduct = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 445px;
  top: 130px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: 460px;
  z-index: 3;

  @media screen and (min-width: 2051px) and (max-width: 3000px) {
    left: 1135px;
  }
  @media screen and (min-width: 2001px) and (max-width: 2050px) {
    left: 780px;
  }
  @media screen and (min-width: 1801px) and (max-width: 2000px) {
    left: 669px;
  }
  @media screen and (min-width: 1601px) and (max-width: 1800px) {
    left: 613px;
  }
  @media screen and (min-width: 1501px) and (max-width: 1600px) {
    left: 520px;
  }
  @media screen and (min-width: 1300px) and (max-width: 1500px) {
    left: 445px;
  }
  @media screen and (min-width: 1100px) and (max-width: 1299px) {
    left: 384px;
  }
  @media screen and (min-width: 1092px) and (max-width: 1099px) {
    left: 309px;
  }
  @media screen and (min-width: 500px) and (max-width: 1092px) {
    left: 220px;
  }
`

export const Filtro = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

export const Container = styled.div`
  padding-top: 15%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colors.overlay};
  display: block;
  z-index: 1;
`
export const Modal = styled.div`
  width: 400px;
  height: '260px';
  background-color: ${colors.surface};
  margin: 0 auto;
  text-align: center;
  border-radius: 10px;
  padding: 30px;
`

export const DivForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  align-items: center;
  margin-top: 25px;
`

export const Form = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`

export const Label = styled.label<{ left: string; integracao?: boolean }>`
  position: absolute;
  top: ${({ integracao }) => (integracao ? '-9px' : '22px')};
  color: ${colors.grey900};
  left: ${({ left }) => left};
  padding: 0 3px;
  font-size: 12px;
  background-color: ${colors.surface};
`

export const Input = styled.input<{ width: string; integracao?: boolean }>`
  /* Transparente de proposito: o rotulo flutuante recorta a borda deste campo, e
     esse recorte so funciona se campo e container tiverem a MESMA cor. Com o campo
     preenchido, o rotulo atravessa a fronteira e vira uma caixa visivel. Campos SEM
     rotulo flutuante (busca, filtros) seguem preenchidos pela base do GlobalStyle. */
  background-color: transparent;
  width: ${({ width }) => width};
  height: 23px;
  border: 1px solid ${colors.grey300};
  border-radius: 12px;
  font-size: 14px;
  padding: 20px 20px 20px 10px;
  margin-top: ${({ integracao }) => (integracao ? '0px' : '30px')};
`

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const ButtonClosed = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`

export const ContainerTitleInativaOrganizacao = styled.div`
  text-align: center;
  width: 330px;
  font-size: 22px;
  font-weight: 600;
  margin: 0px auto 30px auto;
`

export const ButtonsCancelarPedido = styled.div<{ integracao?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 370px;
  margin: 0 auto;
`
export const Ul = styled.div`
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: start;
  gap: 10px;

  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  color: ${colors.grey900};
`
